import { elsterDocxUtils, emptyLine } from '../utils/elster_docx_utils';
import i18n from 'i18next';
import generalTable from '../utils/generalTable';
import { grayTitlesMain } from '../styles/elsterDocStyles';
import { GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_ELEVEN, GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_NINE, GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_TEN } from '../constants/elsterDocxConstants';
const renderPartyTables = (party, mainParagraphOptions) => {
  const {
    t
  } = i18n;
  const {
    createTextRunInParagraph
  } = elsterDocxUtils;
  return [createTextRunInParagraph(t('details_of_the_parties_involved_in_the_assessment'), grayTitlesMain, mainParagraphOptions), generalTable(party, GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_TEN), createTextRunInParagraph(t('information_on_breakdown_11'), grayTitlesMain, mainParagraphOptions), generalTable(party, GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_ELEVEN), emptyLine];
};
const partnershipSection = (data, mainParagraphOptions) => {
  var _data$partnership_and, _data$partnership_and2, _data$partnership_and3, _data$partnership_and4;
  const {
    t
  } = i18n;
  const {
    createTextRunInParagraph
  } = elsterDocxUtils;
  const partnership = (_data$partnership_and = data === null || data === void 0 || (_data$partnership_and2 = data.partnership_and_parties) === null || _data$partnership_and2 === void 0 ? void 0 : _data$partnership_and2.partnership) !== null && _data$partnership_and !== void 0 ? _data$partnership_and : {};
  const parties = (_data$partnership_and3 = data === null || data === void 0 || (_data$partnership_and4 = data.partnership_and_parties) === null || _data$partnership_and4 === void 0 ? void 0 : _data$partnership_and4.partnership_parties) !== null && _data$partnership_and3 !== void 0 ? _data$partnership_and3 : [];
  const partiesToRender = Array.isArray(parties) && parties.length > 0 ? parties : [{}]; // makes sure there is at least one table to render if there are no parties

  const partnershipTables = [createTextRunInParagraph(t('additional_information_for_partnership'), grayTitlesMain, mainParagraphOptions), createTextRunInParagraph(t('additional_information_for_partnership_subtitle'), grayTitlesMain, mainParagraphOptions), generalTable(partnership, GENERAL_COMPANY_INFORMATION_TABLE_INSTRUCTIONS_NINE)];
  const partyTables = partiesToRender.flatMap(party => renderPartyTables(party, mainParagraphOptions));
  return [...partnershipTables, ...partyTables];
};
export default partnershipSection;